import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../core/services/auth.service';
import { AppStateService } from '../core/services/app-state.service';
import { CarouselComponent } from '@wuitk/angular/components/carousel';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  providers: [Location]
})
export class DashboardComponent implements OnInit {
  public cols: number = 1;
  public rowHeight: string = '10px';

  public getImage(name: string): string {
      return `assets/images/clinical/${name}.jpg`;
  }

  isDropdownOpen = false;
  isLoggedIn$: Observable<boolean>;
  userName: string;
  constructor(
    private authService: AuthService,
    public appState: AppStateService,
    private dialog: MatDialog
) {}
public carouselType: string = 'multiple-with-side-navigation';
public responsiveBreakpoints = {
  '0': 1,
  '600': 2,
  '1000': 3
};
public title: string = 'Dashboard';
public offset: number = 5;
public showDotNavigation: boolean = true;
public items = [
  { title1: 'Organization Management', routerLink: '/organization', image: 'img-clinical-2', requiredPermissions: ['AccessProductSupportConsole', 'AccessSapphire'] },
  { title1: 'Patient Management System', routerLink: '/patient-search', image: 'img-clinical-3' },
  { title1: 'Equipment Management System', routerLink: '/equipment', image: 'img-clinical-5' },
  { title1: 'Rules Execution System', routerLink: '/rules', image: 'img-clinical-6' },
  { title1: 'Reports and Templates', routerLink: '/report', image: 'img-clinical-7' }
];
public dots: number = Math.ceil(this.items.length / this.offset);
public activeDot: number = 0;
@ViewChild(CarouselComponent, { static: false }) public carousel: CarouselComponent;

public onCarouselChange(event: any) {
    this.activeDot = event.currentScreen;
    this.dots = Math.ceil(this.items.length / event.slideOffset);
    // As per design spec maximum dot navigator is 8 if  > 8 then dot navigator will not be used and only the arrows will be shown
    if (this.dots <= 8) {
        this.showDotNavigation = true;
    } else {
        this.showDotNavigation = false;
    }
}

public panelClicked(event: any) {
    if ((event.selectedIndexOfDot > this.activeDot) && (event.selectedIndexOfDot !== this.activeDot)) {
        // For carousel dot navigation index should start with 1 not 0, but in dot navigator the index value starts from 0 so adding 1 to it
        this.carousel.next(event.selectedIndexOfDot + 1);
    } else {
        if (event.selectedIndexOfDot !== this.activeDot) {
            // For carousel dot navigation index should start with 1 not 0, but in dot navigator the index value starts from 0 so adding 1 to it
            this.carousel.prev(event.selectedIndexOfDot + 1);
        }
    }
}

public onClickViewAll(event: any) { /* do nothing */ }

ngOnInit() {
  if (window.location.pathname && window.location.pathname.indexOf('/dashboard') > -1) {
    this.appState.setIsInDashboardPage(true);
  }
  this.userName = 'this.authService.userName';
  this.isLoggedIn$ = this.authService.isLoggedIn;
}
toggleDropDown(event) {
  event.stopImmediatePropagation();
  this.isDropdownOpen = !this.isDropdownOpen;
}

hideDropDown() {
this.isDropdownOpen = false;
}

signout() {
// this.sessionExpireService.clearCheckTimeOutSubcription();
// Utils.clearSessionObjects('TIMER');
// if (this.appState.getIsFilterPanelOpen()) {
//     this.appState.toggleFilterPanel$.emit();
// }
// this.authService.logout();
// this.analyticsService.trackConversion('logout');
}

get filteredItems() {
  return this.items.filter(item => {
    if (!item.requiredPermissions) return true;
    return item.requiredPermissions.some(perm => this.authService.hasPermission && this.authService.hasPermission(perm));
  });
}
}
